const ADJUST_ENDPOINT_FOR_PDF = 'ADJUST_ENDPOINT_FOR_PDF';
const API_PDF_ENDPOINT = 'http://edurio-legacy-monolith'
const RESULTS_PDF_ENDPOINT = 'http://edurio-legacy-results'
const TRANSLATION_ENDPOINT = 'http://minio:9000/local-translationcompiler-translations'

const isPdf = () => {
    return /true/.test(localStorage.getItem(ADJUST_ENDPOINT_FOR_PDF))
}

const checkEndpointForPdf = (target) => {
    return isPdf() ? API_PDF_ENDPOINT : target;
}

const updateWindowEndpoints = () => {
    if (!isPdf()) return;

    window.api_endpoint = API_PDF_ENDPOINT;
    window.endpoint_ish = RESULTS_PDF_ENDPOINT;
    window.endpoint_translations = TRANSLATION_ENDPOINT;
}

export {
    checkEndpointForPdf,
    updateWindowEndpoints
}
